import { render, staticRenderFns } from "./TypeActors.vue?vue&type=template&id=865d9430&"
import script from "./TypeActors.vue?vue&type=script&lang=ts&"
export * from "./TypeActors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports